import React, { useEffect, useState } from 'react';
import Tooltip from 'react-simple-tooltip';

import { useGlobalContext } from '../../AppContext';
import { parseMoney, parseNumber, parsePercentage } from '../../utils/utils';

import './MyWalletData.scss';

export const MyWalletData = () => {
  const { config, preparing, demoMode, isMobile } = useGlobalContext();
  const [loading, setLoading] = useState(true);
  const [nftCount, setNftCount] = useState<any>('?');
  const [ensCount, setEnsCount] = useState<any>('?');

  useEffect(() => {
    setLoading(preparing);
    //console.log(config);
  }, [preparing]);
  useEffect(() => {
    if (config.nftLoaded && !demoMode) {
      setNftCount(
        Object.values(config.nft)
          .reduce((partialSum: number, a: any) => partialSum + a, 0)
          .toString(),
      );

      setEnsCount(
        Object.values(config.ens)
          .reduce((partialSum: number, a: any) => partialSum + a, 0)
          .toString(),
      );
    } else {
      setNftCount('?');
      setEnsCount('?');
    }
  }, [config]);

  return (
    <>
      <div className={`my-wallet-data-address`}>
        {loading || demoMode ? (
          <>
            <div className="mt-2 d-flex justify-content-between align-items-center change-interval sh-small">
              # of Tokens{' '}
              <Tooltip
                placement={isMobile ? 'left' : 'right'}
                className="tooltip"
                border="#ff6aff"
                background="var(--color-background-main)"
                color="var(--color-text-main)"
                content="Total unique token count in portfolio."
              >
                <div className="portfolio-value sh-small text-color-three">{parseNumber(46)}</div>
              </Tooltip>
            </div>

            <div className="mt-2 d-flex justify-content-between align-items-center change-interval sh-small">
              # of NFT{' '}
              <Tooltip
                placement={isMobile ? 'left' : 'right'}
                className="tooltip"
                border="#ff6aff"
                background="var(--color-background-main)"
                color="var(--color-text-main)"
                content="Total NFT count in portfolio."
              >
                <div className="portfolio-value sh-small text-color-four">{parseNumber(64)}</div>
              </Tooltip>
            </div>

            <div className="mt-2 d-flex justify-content-between align-items-center change-interval sh-small">
              # of ENS{' '}
              <Tooltip
                placement={isMobile ? 'left' : 'right'}
                className="tooltip"
                border="#ff6aff"
                background="var(--color-background-main)"
                color="var(--color-text-main)"
                content="Total ENS count in portfolio."
              >
                <div className="portfolio-value sh-small text-color-six">{parseNumber(5)}</div>
              </Tooltip>
            </div>

            <div className="mt-2 d-flex justify-content-between align-items-center change-interval sh-small">
              24H PNL{' '}
              <Tooltip
                placement={isMobile ? 'left' : 'right'}
                className="tooltip"
                border="#ff6aff"
                background="var(--color-background-main)"
                color="var(--color-text-main)"
                content="Total changes of your main portfolio in 24 hours."
              >
                <div className="change-amount sh-small text-color-one">
                  {parseMoney(124)}
                  <span className="">( {parsePercentage(6)})</span>
                </div>
              </Tooltip>
            </div>

            <div className="mt-2 d-flex justify-content-between align-items-center change-interval sh-small">
              Total Fee{' '}
              <Tooltip
                placement={isMobile ? 'left' : 'right'}
                className="tooltip"
                border="#ff6aff"
                background="var(--color-background-main)"
                color="var(--color-text-main)"
                content="Total spent fee in current USD currency."
              >
                <div className="portfolio-value sh-small text-color-two">{parseMoney(1423)}</div>
              </Tooltip>
            </div>

            <div className="total-fee mt-4 text-color-black">
              <Tooltip
                placement={isMobile ? 'left' : 'right'}
                className="tooltip"
                border="#ff6aff"
                background="var(--color-background-main)"
                color="var(--color-text-main)"
                content="Total portfolio USD value."
              >
                {parseMoney(62987)}
              </Tooltip>
            </div>
          </>
        ) : (
          config && (
            <>
              <div className="mt-2 d-flex justify-content-between align-items-center change-interval sh-small">
                # of Tokens{' '}
                <Tooltip
                  placement={isMobile ? 'left' : 'right'}
                  className="tooltip"
                  border="#ff6aff"
                  background="var(--color-background-main)"
                  color="var(--color-text-main)"
                  content="Total unique token count in portfolio."
                >
                  <div className="portfolio-value sh-small text-color-three">
                    {parseNumber(
                      Object.values(
                        Object.keys(config.globalNetworks).map((key: any) => {
                          return Object.values(config.globalNetworks[key].tokens).length;
                        }),
                      ).reduce((a: any, b: any) => a + b, 0),
                    )}
                  </div>
                </Tooltip>
              </div>

              <div className="mt-3 d-flex justify-content-between align-items-center change-interval sh-small">
                # of NFT{' '}
                <Tooltip
                  placement={isMobile ? 'left' : 'right'}
                  className="tooltip"
                  border="#ff6aff"
                  background="var(--color-background-main)"
                  color="var(--color-text-main)"
                  content="Total NFT count in portfolio."
                >
                  <div className="portfolio-value sh-small text-color-four">
                    {parseNumber(nftCount)}
                  </div>
                </Tooltip>
              </div>

              <div className="mt-3 d-flex justify-content-between align-items-center change-interval sh-small">
                # of ENS{' '}
                <Tooltip
                  placement={isMobile ? 'left' : 'right'}
                  className="tooltip"
                  border="#ff6aff"
                  background="var(--color-background-main)"
                  color="var(--color-text-main)"
                  content="Total ENS count in portfolio."
                >
                  <div className="portfolio-value sh-small text-color-six">
                    {parseNumber(ensCount)}
                  </div>
                </Tooltip>
              </div>

              <div className="mt-2 d-flex justify-content-between align-items-center change-interval sh-small">
                24H PNL{' '}
                <Tooltip
                  placement={isMobile ? 'left' : 'right'}
                  className="tooltip"
                  border="#ff6aff"
                  background="var(--color-background-main)"
                  color="var(--color-text-main)"
                  content="Total changes of your main portfolio in 24 hours."
                >
                  <div className="change-amount sh-small text-color-one">
                    {parseMoney(config.pnl.amount)}
                    <span className="">( {parsePercentage(config.pnl.ratio)})</span>
                  </div>
                </Tooltip>
              </div>

              <div className="mt-2 d-flex justify-content-between align-items-center change-interval sh-small">
                Total Fee{' '}
                <Tooltip
                  placement={isMobile ? 'left' : 'right'}
                  className="tooltip"
                  border="#ff6aff"
                  background="var(--color-background-main)"
                  color="var(--color-text-main)"
                  content="Total spent fee in current USD currency."
                >
                  <div className="portfolio-value sh-small text-color-two">
                    {parseMoney(config.fees)}
                  </div>
                </Tooltip>
              </div>

              <div className="total-fee mt-4 text-color-black">
                <Tooltip
                  placement={isMobile ? 'left' : 'right'}
                  className="tooltip"
                  border="#ff6aff"
                  background="var(--color-background-main)"
                  color="var(--color-text-main)"
                  content="Total portfolio USD value."
                >
                  {parseMoney(config.balance)}
                </Tooltip>
              </div>
            </>
          )
        )}
      </div>
    </>
  );
};
